import { pipelineFetch } from './pipeline-auth';

export interface PipelineRun {
  run_id: string;
  status: string;
  file_name?: string;
  file_path?: string;
  created_at?: string;
  updated_at?: string;
  progress?: PipelineProgress;
  error?: string;
  source_type?: string;
  source_query?: string;
  brand_id?: string;
  total_videos?: number;
}

export interface PipelineProgress {
  gemini_analyzed?: boolean;
  claude_frameworks?: boolean;
  uploaded_to_db?: boolean;
  current_step?: string;
  message?: string;
  total?: number;
  uploaded?: number;
}

export async function runPipeline(body: object): Promise<PipelineRun> {
  const res = await pipelineFetch('/api/run-pipeline', {
    method: 'POST',
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`Pipeline error: ${res.statusText}`);
  return res.json();
}

export async function getPipelineStatus(runId: string): Promise<PipelineRun> {
  const res = await pipelineFetch(`/api/status/${runId}`);
  if (!res.ok) throw new Error(`Status error: ${res.statusText}`);
  return res.json();
}

export async function getPipelineRuns(): Promise<PipelineRun[]> {
  const res = await pipelineFetch('/api/runs');
  if (!res.ok) throw new Error(`Runs error: ${res.statusText}`);
  return res.json();
}
